import { Fragment } from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { formatAmountByCurrency } from '../../../services/helper';

const ServicesSummary = ({ summaryItems, summaryTotal, currency }) => {
  const { t } = useTranslation();

  const formatAmmount = (value) => {
    const locateCode = currency && currency.locateCode ? currency.locateCode : 'es-CL';
    const currencyCode = currency && currency.currencyCode ? currency.currencyCode : 'CLP';
    return formatAmountByCurrency({
      countryCode: locateCode,
      currencyCode: currencyCode,
      amount: value,
    })
  };

  return (
    <Row justify="center" className="reservation-settings-wrapper__services-summary mt-30">
      <Col lg={24} xs={24}>
        <Row>
          <h2 className="mb-20">
            {t('reservations.servicesSummary.summaryTitle')}
          </h2>
        </Row>
        <Row className="mb-10">
          <Col lg={8} xs={8}>
            <p className="title ml-15 mb-0">
              {t('reservations.servicesSummary.serviceTitle')}
            </p>
          </Col>
          <Col lg={8} xs={8}>
            <p className="title text-center mb-0">
              {t('reservations.servicesSummary.servicesQuantity')}
            </p>
          </Col>
          <Col lg={8} xs={8}>
            <p className="title text-center mb-0">
              {t('reservations.servicesSummary.priceTitle')}
            </p>
          </Col>
        </Row>
        {
          (summaryItems && summaryTotal) ?
            <Fragment>
              {
                summaryItems.map((item, index) => {
                  return (
                    <Row key={index} className="row-item pt-15 pb-15 mb-10">
                      <Col lg={8} xs={8}>
                        <p className="ml-15 mb-0">{item.name}</p>
                      </Col>
                      <Col lg={8} xs={8}>
                        <p className="text-center mb-0">{item.quantity}</p>
                      </Col>
                      <Col lg={8} xs={8}>
                        <p className="text-center mb-0">{formatAmmount(item.sale_amount)}</p>
                      </Col>
                    </Row>
                  )
                })
              }
              <Row justify="end">
                <Col lg={8} xs={14}>
                  <Row className="row-item pt-15 pb-15">
                    <Col lg={10} xs={10}>
                      <p className="title text-center mb-0">
                        {t('reservations.servicesSummary.totalTitle')}
                      </p>
                    </Col>
                    <Col lg={14} xs={14}>
                      <p className="title mb-0">{formatAmmount(summaryTotal.totalValue)}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Fragment>
            :
            <Row justify="center">
              <p className="text-center mt-20">
                {t('reservations.servicesSummary.disclaimerExistence')}
              </p>
            </Row>
        }
      </Col>
    </Row>
  );
};

export default ServicesSummary;
